<template>
  <router-view />
</template>

<script>
import jwtDecode from 'jwt-decode'
import { hidesCrisp } from '@/plugins/Crisp'
export default {
  created () {
    // updates store from localStorage
    this.$store.commit('USER/UPDATE_FROM_LOCAL_STORAGE')
    this.$store.commit('ADMIN/UPDATE_FROM_LOCAL_STORAGE_ADMIN')

    if (this.$store.state.USER.user.token) {
      this.$crisp.setTokenId(jwtDecode(this.$store.state.USER.user.token).id)

      this.$crisp.load()

      this.$crisp.user.setEmail(this.$store.state.USER.user.email)
      this.$crisp.user.setNickname(this.$store.state.USER.user.firstName)

      // On a hard load of /chatbot the router guard hides it again anyway,
      // but $route is not resolved yet here so check the URL directly.
      if (!hidesCrisp(window.location.pathname)) {
        this.$crisp.chat.show()
      }
    }
  }

}
</script>

<style>

</style>
